import { installPromiseWithResolversPolyfill } from './promise-with-resolvers';

export function installPolyfills(): void {
  installPromiseWithResolversPolyfill();
}

// Auto-execute on import
installPolyfills();
